import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useBrandsList() {

    //User toast
    const toast = useToast()

    const refBrandListTable = ref(null)

    const tableColumns = [
        {key: 'name', label:'品牌', sortable: true},
        {key: 'description', label:'描述'},
        {key: 'sort_order', label:'排序', sortable: true},
        {key: 'is_active', label:'狀態', sortable: true},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalBrands = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('sort_order')
    const isSortDirDesc = ref(false)

    const dataMeta = computed(() => {
        const localItemsCount = refBrandListTable.value ? refBrandListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBrands.value,
        }
    })

    const refetchData = () => {
        refBrandListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchBrands = (ctx, callback) => {
        store.dispatch('setting-brand/fetchBrands',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {product_brands, total} = response.data
            callback(product_brands)
            totalBrands.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching brands list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchBrands,
        tableColumns,
        perPage,
        currentPage,
        totalBrands,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBrandListTable,
        ability,
        refetchData
    }

}